export default __webpack_public_path__ + "static/media/mortysWorld.a7db79db.png";